<div class="row noselect">
  <h3 style="display: flex; align-items: center;">
    <app-back-button *ngIf="!hideback"></app-back-button>
    <span [ngStyle]="{ 'padding-left': hideback ? '24px' : '0' }">
      {{ text }}
    </span>
  </h3>
</div>